(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ni-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ni-size-guide')) {
    customElements.define('ni-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if (this.querySelector('[data-comparison]')) this.initialize();
        else {
          this.observer = new MutationObserver(() => {
            if (!this.querySelector('[data-comparison]')) return;
            this.observer.disconnect();
            this.initialize();
          });
          this.observer.observe(this, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      initialize() {
        if (this.ready) return;
        this.ready = true;
        const original = this.querySelector('[data-original]');
        const source = original.querySelector('table');
        if (!source) return;
        const rows = Array.from(source.rows);
        if (rows.length < 3) return;
        const sizes = Array.from(rows[0].cells).slice(1);
        const units = Array.from(rows[1].cells).slice(1);
        const measurements = rows.slice(2).map(row => Array.from(row.cells).map(cell => cell.textContent.trim()));
        if (!sizes.length || sizes.some(cell => cell.colSpan !== 2 || !cell.textContent.trim())) return;
        if (units.length !== sizes.length * 2 || measurements.some(row => row.length !== units.length + 1)) return;
        if (units.some((cell, index) => !((index % 2 ? /^(cm|centimeters?)$/i : /^(in|inch|inches)$/i).test(cell.textContent.trim())))) return;
        const select = this.querySelector('[data-guide-size]');
        const body = this.querySelector('[data-measurements]');
        sizes.forEach((cell, index) => {
          const option = document.createElement('option');
          option.value = index;
          option.textContent = cell.textContent.trim();
          option.selected = option.textContent === this.dataset.selectedSize;
          select.append(option);
        });
        const update = () => {
          const index = Number(select.value);
          body.replaceChildren();
          measurements.forEach(measurement => {
            const row = document.createElement('tr');
            [measurement[0], measurement[index * 2 + 1], measurement[index * 2 + 2]].forEach((value, column) => {
              const cell = document.createElement(column ? 'td' : 'th');
              if (!column) cell.scope = 'row';
              cell.textContent = value;
              row.append(cell);
            });
            body.append(row);
          });
          this.querySelector('[data-size-name]').textContent = sizes[index].textContent.trim();
        };
        select.addEventListener('change', update);
        update();
        const comparison = this.querySelector('[data-comparison]').content.firstElementChild.cloneNode(true);
        original.before(comparison);
        comparison.append(original);
        this.querySelector('[data-measurement-view]').hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
